import { useCallback, useEffect, useState } from "react";
import { academyRequest } from "./academyApi";

export type InstructorAssignmentAnalytics = {
  metricKey: "teaching.current_assignment_count";
  definitionVersion: number;
  sourceDomain: "D07";
  availability: "available" | "stale" | "not_projected";
  values: { current?: number };
  suppressedCells: number;
  minimumCellCount: number;
  freshnessSeconds: number;
  calculatedAt: string | null;
  expiresAt: string | null;
  instructorUserId: string;
  capacityAvailable: false;
  effortAvailable: false;
  performanceAvailable: false;
  transactionalAuthority: false;
};

export function useInstructorAssignmentAnalytics(enabled: boolean) {
  const [data, setData] = useState<InstructorAssignmentAnalytics>();
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError("");
    try {
      setData(
        await academyRequest<InstructorAssignmentAnalytics>("instructor/dashboard/analytics/assignments"),
      );
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Instructor assignment analytics are unavailable.");
    } finally {
      setLoading(false);
    }
  }, [enabled]);
  useEffect(() => {
    if (enabled) void refresh();
    else {
      setData(undefined);
      setError("");
      setLoading(false);
    }
  }, [enabled, refresh]);
  return { data, loading, error, refresh };
}
